import { getBasicSingleInitialState, getBasicSingleReducerSlice } from '@probatix/common/utils/service'

import { STATE_KEY } from '../accountsService.constants'
import { AccountsSingleState } from '../accountsService.model'

export const slice = getBasicSingleReducerSlice<AccountsSingleState>(
  getBasicSingleInitialState(),
  STATE_KEY,
)

export default slice.reducer
